import { Reducer } from "redux";

import {
  HIDE_POPUP,
  SHOW_POPUP,
  EDIT_POPUP_TEXT,
  EditPopupAction,
  HidePopupAction,
  ShowPopupAction,
} from "../actions/toast";

interface Popup {
  status: boolean;
  description: {
    main: string;
    sub?: string;
  };
}

interface PopupReducer
  extends Reducer<Popup, EditPopupAction | HidePopupAction | ShowPopupAction> {}

const initialState: Popup = {
  status: false,
  description: {
    main: "",
    sub: "",
  },
};

const popup: PopupReducer = function (state = initialState, action) {
  switch (action.type) {
    case SHOW_POPUP:
      return {
        ...state,
        status: true,
      };
    case HIDE_POPUP: {
      return initialState;
    }
    case EDIT_POPUP_TEXT: {
      return { status: true, description: action.body };
    }
    default:
      return state;
  }
};

export default popup;
